import * as React from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";

const FilledButton = React.forwardRef((props,ref) => {
  const {
    color,
    bgColor,
    beforeColor,
    btnText,
    startIcon,
    endIcon,
    fullWidth,
    sx,
    cstHover,
    handleClick,
    type,
    value,
    disabled,
    id
  } = props;
  // const { clickEvent } = props;
  return (
    <Button
      id={id}
      // ref={ref}
      variant="contained"
      handleClick={handleClick}
      type={type}
      value={value}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={handleClick}
      sx={{
        color: color,
        backgroundColor: bgColor,
        mx: 1,
        px: { xs: 2, md: 4 },
        py: { xs: 1.5, md: 1.5 },
        fontWeight: 500,
        fontSize: { xs: 12, md: 16 },
        borderRadius: "6px",
        minWidth: "max-content",
        height: "fit-content",
        textTransform: "unset",
        ...sx,
        "&:hover": {
          backgroundColor: color,
          color: bgColor,
        },
        "&:hover svg path": {
          fill: bgColor,
        },
        ...cstHover,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {startIcon ? (
          <Box
            sx={{
              mt: 1,
              svg: {
                path: {
                  fill: color,
                  color: color,
                },
              },
            }}
          >
            {startIcon}
          </Box>
        ) : null}

        {btnText ? (
          <Box
            sx={{
              ...(startIcon && { ml: "0.2rem" }),
              ...(endIcon && { mr: "0.2rem" }),
            }}
          >
            {btnText}
          </Box>
        ) : null}

        {endIcon ? (
          <Box
            sx={{
              mt: 1,
              svg: {
                path: {
                  fill: color,
                  color: color,
                },
              },
            }}
          >
            {endIcon}
          </Box>
        ) : null}
      </Box>
    </Button>
  );
})
 export default FilledButton